const addUserToNewsletter = async ({email, tags}) => {
  try {
    const response = await fetch('/api/subscribe-newsletter', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email,
        tags
      })
    });

    return response.json();
  } catch (error) {
    console.log(error);
  }
};

export default addUserToNewsletter;
